<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Trainers"
      target="toggleGroupTrainers"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupTrainers" class="collapse show row">
      <div v-if="showDistTrainerCheckbox" class="col-12 mb-3">
        <Field
          type="checkbox"
          name="allow_dist_trainer"
          id="cb_allow_dist_trainer"
          label="Allow Distributor Trainers of the Sponsoring Distributorship to train this Authorized Training course"
          v-model="allowDistTrainer"
          :checkbox-value="1"
        />
      </div>

      <div class="col-3 mb-4">
        <Field
          type="select"
          name="trainer_company"
          label="Trainer Company"
          v-model="selectedCompany"
          :options="companies"
          :hideSelectEmptyOption="true"
          :disabled="companies.length == 0"
        />
      </div>

      <div class="col-3 mb-3">
        <Field
          type="select"
          name="trainer"
          label="Trainer"
          v-model="selectedTrainer"
          :options="trainerOptions"
          :hideSelectEmptyOption="true"
        />
      </div>

      <div class="col-6 mb-3 add-btn-wrap">
        <a class="btn btn-info" href="#" @click.prevent="add()">
          Assign Trainer
        </a>
      </div>

      <div class="col-12">
        <div v-if="assigned.length > 0" class="multi-assign-values">
          <a
            v-for="id in assigned"
            :key="id"
            class="pill"
            href="#"
            @click.prevent="remove(id)"
          >
            <span class="text">{{ trainerName(id) }}</span>
            <icon icon="remove" class="icon" />
            <input type="hidden" name="trainers[]" :value="id" />
          </a>
        </div>
      </div>

      <div v-if="showTrainerRSVP" class="col-12">
        <div v-if="isConfirmed" class="alert alert-success">
          <p class="m-0">
            The trainer has CONFIRMED that they are available to train this
            event.
          </p>
        </div>
        <div v-else-if="isConfirmedWithChanges" class="alert alert-warning">
          <p class="m-0">
            The trainer has CONFIRMED that they are available to train this
            event, provided the following changes are made:
          </p>
          <p class="m-0">
            <em>{{ event.trainer_rsvp_notes }}</em>
          </p>
        </div>
        <div v-else-if="isRejected" class="alert alert-danger">
          <p class="m-0">
            The trainer has REJECTED the request for them to train this event
            for the following reason:
          </p>
          <p class="m-0">
            <em>{{ event.trainer_rsvp_notes }}</em>
          </p>
        </div>
        <div v-else class="alert alert-info">
          <p class="m-0">
            The trainer has NOT YET RESPONDED regarding their availability to
            train this event.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    event: { type: Object, required: true },
    course: { type: Object, default: () => {} },
    sponsorId: { type: [String, Number] },
  },

  data() {
    return {
      companies: [],
      trainers: [],
      allowDistTrainer: false,
      selectedCompany: null,
      selectedTrainer: null,
      assigned: [],
    };
  },

  computed: {
    showDistTrainerCheckbox() {
      return !!this.course && !!this.course.authorized_training;
    },
    trainerOptions() {
      if (!this.course) {
        return [
          {
            label: "-- No Course Selected --",
            value: null,
          },
        ];
      }
      return this.trainers.filter((t) => {
        return this.companies.length == 0 || t.company == this.selectedCompany;
      });
    },
    trainerRSVP() {
      return this.event.trainer_rsvp || 0;
    },
    showTrainerRSVP() {
      return (
        this.event.status == this.$root.constants.REQUESTED_EVENT ||
        this.trainerRSVP > 0
      );
    },
    isConfirmed() {
      return this.trainerRSVP == this.$root.constants.TRAINER_RSVP_CONFIRM;
    },
    isConfirmedWithChanges() {
      return this.trainerRSVP == this.$root.constants.TRAINER_RSVP_CHANGES;
    },
    isRejected() {
      return this.trainerRSVP == this.$root.constants.TRAINER_RSVP_REJECT;
    },
  },

  watch: {
    course(val) {
      this.load();
    },
    sponsorId(val) {
      this.load();
    },
    allowDistTrainer(val) {
      this.load();
    },
    trainers(val) {
      this.prune();
    },
    selectedCompany(val) {
      this.selectedTrainer = null;
    },
  },

  methods: {
    load: _.debounce(function () {
      if (!this.course) {
        return;
      } else if (!this.event.icp_sponsored && !!this.course.trainers && this.course.trainers.length > 0) {
        this.companies = [];
        this.trainers = this.course.trainers.map((t) => {
          return { label: t.name, value: t.id };
        });
      } else {
        var url = this.route("admin.events.trainers", {
          course: this.course.id,
        });
        this.axios(url, {
          params: {
            sponsor_id: this.sponsorId,
            allow_dist_trainer: this.allowDistTrainer,
          },
        }).then((response) => {
          this.companies = response.data.companies || [];
          this.trainers = response.data.trainers || [];
        });
      }
    }, 300),
    isAssigned(id) {
      return this.assigned.filter((a) => a == id).length > 0;
    },
    add() {
      if (!this.selectedTrainer) {
        alert("Please choose a trainer before continuing.");
        return;
      } else if (this.isAssigned(this.selectedTrainer)) {
        alert("You have already assigned this trainer to the event.");
        return;
      }
      this.assigned.push(this.selectedTrainer);
    },
    prune() {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter((a) => {
        return !!this.trainers.find((t) => t.value == a);
      });
    },
    remove(id) {
      let assigned = this.assigned;
      this.assigned = [];
      this.assigned = assigned.filter((a) => a != id);
    },
    trainerName(id) {
      let trainer = this.trainers.filter((t) => t.value == id)[0];
      return !!trainer ? trainer.label : "";
    },
  },

  mounted() {
    this.allowDistTrainer = !!this.event.allow_dist_trainer || false;
    this.assigned = this.event._trainers || [];
    this.load();
  },
};
</script>

<style scoped>
@media (min-width: 1200px) {
  .add-btn-wrap {
    padding-top: 30px;
  }
}
</style>